module.exports = __webpack_public_path__ + "static/media/room-05.03fd8f3f.jpg";